import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgArrow = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 10,
	height: 18,
	viewBox: "0 0 10 18",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M9.45 4.06452L5.57308 0.300334C5.16923 -0.100111 4.52308 -0.100111 4.11923 0.300334L0.323077 4.06452C0.0807692 4.30478 0 4.54505 0 4.78532C0 5.02558 0.0807692 5.26585 0.323077 5.50612C0.726923 5.90656 1.37308 5.90656 1.77692 5.50612L3.87692 3.4238V17.4394C4.03846 17.7597 4.44231 18 4.84615 18C5.25 18 5.73462 17.7597 5.81538 17.3593V3.4238L7.91538 5.50612C8.31923 5.90656 8.96538 5.90656 9.36923 5.50612C9.61154 5.34594 9.69231 5.02558 9.69231 4.78532C9.69231 4.54505 9.61154 4.30478 9.45 4.06452Z",
		fill: "currentColor"
	})
});
export default SvgArrow;
